var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTubeFlower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100.049,
    height: 99.933,
    viewBox: "0 0 100.049 99.933",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M67.663,88.544,50.809,59.351,64.123,67.04,74.32,84.7a3.843,3.843,0,0,1-6.657,3.843M45.922,92.212V58.646l7.686,13.311V92.212a3.843,3.843,0,0,1-7.686,0M84.633,74.4,55.79,57.748h15.37l17.315,10A3.843,3.843,0,0,1,84.633,74.4M26.941,90.027a3.846,3.846,0,0,1-1.407-5.25L42.043,56.183V71.556L32.191,88.618a3.857,3.857,0,0,1-3.337,1.923,3.817,3.817,0,0,1-1.913-.514M9.984,73.056a3.848,3.848,0,0,1,1.407-5.25L40.583,50.954,32.894,64.268,15.234,74.463a3.84,3.84,0,0,1-5.25-1.407M71.665,46.182H92.326a3.843,3.843,0,1,1,0,7.686H58.352ZM3.879,49.908a3.85,3.85,0,0,1,3.843-3.843H41.289L27.978,53.751H7.722a3.848,3.848,0,0,1-3.843-3.843m7.694-17.718a3.843,3.843,0,0,1,3.843-6.657L44.261,42.185H28.89Zm55.783,3.125,17.459-10.08a3.842,3.842,0,1,1,3.843,6.654L59.672,48.626ZM35.926,32.9l-10.2-17.663a3.843,3.843,0,1,1,6.657-3.843l16.854,29.19Zm22.08-4.515L67.86,11.315a3.842,3.842,0,1,1,6.654,3.843L58.006,43.753Zm-11.566-.4V7.721a3.844,3.844,0,0,1,7.689,0V41.29ZM50.106,0a7.728,7.728,0,0,0-7.542,7.72V21.258L35.746,9.449A7.722,7.722,0,1,0,22.37,17.172l6.837,11.844L17.358,22.172A7.722,7.722,0,1,0,9.636,35.548l11.494,6.637H7.722a7.722,7.722,0,0,0,0,15.445H21.257L9.451,64.448a7.721,7.721,0,1,0,7.722,13.373l11.842-6.834L22.176,82.836a7.721,7.721,0,1,0,13.373,7.722l6.493-11.244v12.9a7.722,7.722,0,0,0,15.445,0V78.678L64.3,90.484a7.721,7.721,0,1,0,13.373-7.722L70.842,70.919l11.849,6.839a7.722,7.722,0,1,0,7.725-13.373l-11.5-6.637H92.326a7.722,7.722,0,1,0,0-15.445H78.384L90.6,35.25a7.723,7.723,0,0,0-7.725-13.376L71.238,28.594l6.637-11.5A7.722,7.722,0,0,0,64.5,9.375L58.006,20.619V7.721A7.728,7.728,0,0,0,50.464,0Z",
    transform: "translate(0 -0.001)",
    fill: "#72cddc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "tube-flower",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    "data-name": "Rectangle 40",
    width: 100.049,
    height: 99.933,
    transform: "translate(0 0)",
    fill: "#72cddc"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTubeFlower);
export default __webpack_public_path__ + "static/media/tube-flower.dcbc53a31c39918d7cf6098587338fe6.svg";
export { ForwardRef as ReactComponent };